<script lang="ts" module>
	const showAsteriskWhenRequired = false;
</script>

<script lang="ts">
	import type { Snippet } from "svelte";
	import type { ClassValue, HTMLAttributes, HTMLInputAttributes, HTMLLabelAttributes } from "svelte/elements";

	const {
		horizontal,
		label,
		required,
		content,
		wrapperClass,
		...rest
	}: HTMLAttributes<HTMLDivElement> & {
		wrapperClass?: ClassValue;
		required?: HTMLInputAttributes["required"];
		horizontal?: boolean;
		label?: HTMLLabelAttributes;
		content: Snippet;
	} = $props();
</script>

<div class={["flex text-left gap-1.5 md:gap-3", horizontal ? "flex-row items-center" : "flex-col", wrapperClass]}>
	{#if horizontal}
		{@render content()}
	{/if}
	<label {...label}>
		{@render rest.children?.()}
		{#if required && showAsteriskWhenRequired}
			<span class="text-cmcprimary self-start cursor-help" title="Pole je povinné">*</span>
		{/if}
	</label>
	{#if !horizontal}
		{@render content()}
	{/if}
</div>
